(() => {
  const desktop = window.matchMedia('(min-width: 1150px)');
  let button;
  let originalTop = Number.POSITIVE_INFINITY;
  let frame;

  const sync = () => {
    frame = undefined;
    if (!button) return;

    button.classList.toggle(
      'hdt-filter-btn--sticky',
      desktop.matches && window.scrollY > originalTop,
    );
  };

  const scheduleSync = () => {
    if (!frame) frame = window.requestAnimationFrame(sync);
  };

  const initialise = () => {
    button?.classList.remove('hdt-filter-btn--sticky');
    button = document.querySelector('[main-content] .hdt-shop-control .hdt-filter_btn');
    if (!button) return;

    originalTop = button.getBoundingClientRect().top + window.scrollY;
    scheduleSync();
  };

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', initialise);
  desktop.addEventListener('change', initialise);
  document.addEventListener('products:update', () => window.requestAnimationFrame(initialise));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
